import { useState } from "react";

interface PaymentErrorState {
  errMsg: string | undefined;
  cardErrMsg: string;
  failedReason: string | null;
  isDateErr: boolean;
  numberNotmatchedError: boolean;
}

interface UsePaymentErrorsReturn extends PaymentErrorState {
  setErrMsg: (msg: string | undefined) => void;
  setCardErrMsg: (msg: string) => void;
  setFailedReason: (reason: string | null) => void;
  setIsDateErr: (err: boolean) => void;
  setnumberNotmatchedError: (err: boolean) => void;
  clearErrors: () => void;
}

export const usePaymentErrors = (): UsePaymentErrorsReturn => {
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const [cardErrMsg, setCardErrMsg] = useState<string>("");
  const [failedReason, setFailedReason] = useState<string | null>(null);
  const [isDateErr, setIsDateErr] = useState<boolean>(false);
  const [numberNotmatchedError, setnumberNotmatchedError] =
    useState<boolean>(false);

  const clearErrors = () => {
    setErrMsg(undefined);
    setCardErrMsg("");
    setFailedReason(null);
    setIsDateErr(false);
    setnumberNotmatchedError(false);
  };

  return {
    errMsg,
    cardErrMsg,
    failedReason,
    isDateErr,
    numberNotmatchedError,
    setErrMsg,
    setCardErrMsg,
    setFailedReason,
    setIsDateErr,
    setnumberNotmatchedError,
    clearErrors,
  };
};
